import { useContext } from "react";
import { SocketContext } from "../context/SocketProvider";
import { FaChevronRight } from "react-icons/fa6";
import { GAME_STAGES, DEFAULT_ROOM, HOME_PATH } from "../constants/gameStages";
import { useNavigate } from "react-router-dom";
import { useGameStage } from "../hooks/useGameStage";

export default function PausedOverlay() {
  const { role, socket, setShowPausedOverlay } = useContext(SocketContext);
  const navigate = useNavigate();
  const { updateStage } = useGameStage();

  // Styling based on role
  const headerBgColor = role === "describer" ? "bg-pink400" : "bg-blue-700";
  const buttonColor = role === "describer" ? "btn-pink-sm" : "btn-blue-sm";

  return (
    <div
      className="fixed inset-0 z-50 w-full h-full bg-black/30 overflow-hidden flex items-center justify-center"
      role="dialog"
      aria-modal="true"
    >
      <article className="w-[514px] h-48 rounded-2xl overflow-hidden relative bg-white">
        <header
          className={`w-[514px] h-16 ${headerBgColor} flex items-center justify-center`}
        >
          <h2 className="text-center text-white text-xl font-bold font-['Gabarito'] px-4">
            A player has disconnected. Please wait or press the button to start a new game.
          </h2>
        </header>
        <main className="w-[514px] h-32 bg-white relative">
          <button
            className={`${buttonColor} btn-bottom-right`}
            onClick={() => {
              // reset game stage
              socket.emit("reset_room", {
                room: DEFAULT_ROOM,
                resetMode: true,
              });
              // Navigate to home page
              updateStage(GAME_STAGES.WAITING);
              setShowPausedOverlay(false); // Hide overlay on reload
              navigate(HOME_PATH);
            }}
          >
            <span className="btn-text-pos-right-sm">Start Over</span>
            <FaChevronRight className="arrow-pos-right-sm" />
          </button>
        </main>
      </article>
    </div>
  );
}
